<template>
<transition
  >
  <div></div>
  </transition>
</template>

<script>

export default {
  name: "HotSpot",

}
</script>

<style scoped>
.hotpspot {
  position: absolute;
  cursor: pointer;
}
.circle-nav{
  background-color: white;
  width:1.2em;
  height:1.2em;
  border-radius: 50%;
  display: inline-block;
  margin:0.2em;
   opacity:0.5;
}

/* //.circle-nav:active, */
 .hotspot-on {
  opacity:1;
  pointer-events:none;
}

.hotspot-off{
  opacity:0.5;
  pointer-events:auto;
}

@media (max-width: 414px) {
  .circle-nav{
  width:1em;
  height:1em;
}
}
@keyframes scaleIn {
  0% {
    transform: scale(1, 1);
    opacity: 0;
  }
  50% {
    transform: scale(1.5, 1.5);
    opacity: 1;
  }
  100% {
    transform: scale(1, 1);
    opacity: 0;
  }
}

@media (max-width: 414px) {
  .hotspot1 {
    /* top: 3.9em; */
    left: 5.7em;
  }
  .hotspot2 {
    /* top: 3em; */
    right: 12em;
  }
  .hotspot3 {
    /* top: 2em; */
    left: 12em;
  }
  .hotspot4 {
    /* top: 7em; */
    left: 8em;
  }
  .hotspot5 {
    /* top: 11em; */
    left: 12em;
  }
  .hotspot6 {
    /* top: 8em; */
    right: 14em;
  }
  .hotspot7 {
    /* top: 13em; */
    right: 9em;
  }
}
</style>
